import { KeyValuePair } from '../models';

const map: KeyValuePair[] = [
  { key: 'cylinder_count', value: 'Number of cylinders' },
  {
    key: 'engine_speed', value: 'Engine speed', unit: 'rpm'
  },
  {
    key: 'speed_mode', value: 'Engine speed mode'
  },
  {
    key: 'cylinder_output', value: 'Cylinder output', unit: 'kW'
  },
  {
    key: 'engine_output', value: 'Engine output', unit: 'kW'
  },
  {
    key: 'electrical_output', value: 'Electrical output', unit: 'kWe'
  },
  {
    key: 'release_status', value: 'Release Status'
  },
  {
    key: 'fuel_type', value: 'Fuel type'
  },
  {
    key: 'mean_effective_pressure', value: 'Mean effective pressure', unit: 'Mpa'
  },
  {
    key: 'mean_piston_speed', value: 'Mean piston speed', unit: 'm/s'
  },
  {
    key: 'final_engine_name', value: 'Engine Configuration'
  },
  {
    key: 'application_types', value: 'Application Type'
  },
  {
    key: 'feature_info', value: 'Feature'
  },
  {
    key: 'product', value: 'Product Name'
  },
  {
    key: 'design_stage', value: 'Design Stage'
  },
  {
    key: 'bore', value: 'Bore', unit: 'mm'
  },
  {
    key: 'stroke', value: 'Stroke', unit: 'mm'
  },
  {
    key: 'designation', value: 'Product name'
  },
  {
    key: 'idling_speed', value: 'Engine idling speed', unit: 'rpm'
  },
  {
    key: 'combustion_air_system', value: 'Combustion Air System'
  },
  {
    key: 'sub_system_note', value: 'Note'
  },
  {
    key: 'air_mass_flow_at100_load_dsl', value: 'CA mass flow at 100% load', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at85_load_dsl', value: 'CA mass flow at 85% load', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at75_load_dsl', value: 'CA mass flow at 75% load', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at50_load_dsl', value: 'CA mass flow at 50% load', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at100_load_gas', value: 'CA mass flow at 100% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at85_load_gas', value: 'CA mass flow at 85% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at75_load_gas', value: 'CA mass flow at 75% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at50_load_gas', value: 'CA mass flow at 50% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at100_load_flex1', value: 'CA mass flow at 100% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at85_load_flex1', value: 'CA mass flow at 85% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at75_load_flex1', value: 'CA mass flow at 75% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'air_mass_flow_at50_load_flex1', value: 'CA mass flow at 50% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'air_temp_ambient_max', value: 'Maximum allowed ambient temperature without derating', unit: '°C'
  },
  {
    key: 'air_temp_after_cooler_min', value: 'Temperature after air cooler, min (TE601)', unit: '°C'
  },
  {
    key: 'air_temp_after_cooler_max', value: 'Temperature after air cooler, max (TE601)', unit: '°C'
  },
  {
    key: 'air_temp_after_cooler_nom', value: 'Temperature after air cooler, nom (TE601)', unit: '°C'
  },
  {
    key: 'air_temp_after_cooler_nom_gas', value: 'Temperature after air cooler, nom, gas mode (TE601)', unit: '°C'
  },
  {
    key: 'air_temp_after_cooler_alarm', value: 'Temperature after air cooler, alarm', unit: '°C'
  },
  {
    key: 'air_temp_after_cooler_stop', value: 'Temperature after air cooler, stop', unit: '°C'
  },
  {
    key: 'air_temp_before_cooler_nom', value: 'Temperature before air cooler, nom', unit: '°C'
  },
  {
    key: 'air_temp_before_cooler_max', value: 'Temperature before air cooler, max', unit: '°C'
  },
  {
    key: 'exhaust_gas_system', value: 'Exhaust Gas System'
  },
  {
    key: 'sub_system_note', value: 'Note'
  },
  {
    key: 'gas_flow_at100_load_dsl', value: 'EG mass flow at 100% load', unit: 'kg/s'
  },
  {
    key: 'gas_flow_at85_load_dsl', value: 'EG mass flow at 85% load', unit: 'kg/s'
  },
  {
    key: 'gas_flow_at75_load_dsl', value: 'EG mass flow at 75% load', unit: 'kg/s'
  },
  {
    key: 'gas_flow_at50_load_dsl', value: 'EG mass flow at 50% load', unit: 'kg/s'
  },
  {
    key: 'gas_flow_at100_load_gas', value: 'EG mass flow at 100% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'gas_flow_at85_load_gas', value: 'EG mass flow at 85% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'gas_flow_at75_load_gas', value: 'EG mass flow at 75% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'gas_flow_at50_load_gas', value: 'EG mass flow at 50% load, gas mode', unit: 'kg/s'
  },
  {
    key: 'flex1_flow_at100_load_flex1', value: 'EG mass flow at 100% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'flex1_flow_at85_load_flex1', value: 'EG mass flow at 85% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'flex1_flow_at75_load_flex1', value: 'EG mass flow at 75% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'flex1_flow_at50_load_flex1', value: 'EG mass flow at 50% load, Methanol', unit: 'kg/s'
  },
  {
    key: 'temperature_after_turbo_charger_at100_load_dsl',
    value: 'Temperature after turbocharger at 100% load (TE517)', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at85_load_dsl',
    value: 'Temperature after turbocharger at 85% load (TE517)', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at75_load_dsl',
    value: 'Temperature after turbocharger at 75% load (TE517)', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at50_load_dsl',
    value: 'Temperature after turbocharger at 50% load (TE517)', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at100_load_gas',
    value: 'Temperature after turbocharger at 100% load (TE517), gas mode', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at85_load_gas',
    value: 'Temperature after turbocharger at 85% load (TE517), gas mode', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at75_load_gas',
    value: 'Temperature after turbocharger at 75% load (TE517), gas mode', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at50_Load_gas',
    value: 'Temperature after turbocharger at 50% load (TE517), gas mode', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at100_load_flex1',
    value: 'Temperature after turbocharger at 100% load (TE517), Methanol', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at85_load_flex1',
    value: 'Temperature after turbocharger at 85% load (TE517), Methanol', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at75_load_flex1',
    value: 'Temperature after turbocharger at 75% load (TE517), Methanol', unit: '°C'
  },
  {
    key: 'temperature_after_turbo_charger_at50_load_flex1',
    value: 'Temperature after turbocharger at 50% load (TE517), Methanol', unit: '°C'
  },
  {
    key: 'temperature_after_cylinder_alarm', value: 'Temperature after cylinder, alarm', unit: '°C'
  },
  {
    key: 'back_pressure_max_dsl', value: 'Exhaust gas backpressure, max', unit: 'kPa (g)'
  },
  {
    key: 'back_pressure_max_gas', value: 'Exhaust gas backpressure, max (GAS)', unit: 'kPa (g)'
  },
  {
    key: 'back_inlet_press_drop_dsl', value: 'Maximum pressure drop at compressor inlet', unit: 'kPa (g)'
  },
  {
    key: 'back_inlet_press_drop_gas', value: 'Maximum pressure drop at compressor inlet (GAS)', unit: 'kPa (g)'
  },
  {
    key: 'pipe_diameter_min', value: 'Exhaust gas pipe diameter, min', unit: 'mm'
  },
  {
    key: 'calculated_exhaust_diameter_dsl', value: 'Calculated exhaust diameter for 35 m/s', unit: 'mm'
  },
  {
    key: 'calculated_exhaust_diameter_gas', value: 'Calculated exhaust diameter for 35 m/s, gas mode', unit: 'mm'
  },
  {
    key: 'heat_balances', value: 'Heat Balances'
  },
  {
    key: 'sub_system_note', value: 'Note'
  },
  {
    key: 'jacket_water_dsl', value: 'Jacket water at 100% load', unit: 'kW'
  },
  {
    key: 'charge_air_arctic_option_dsl', value: 'Charge air at 100% load (LT-circuit, Arctic option)', unit: 'kW'
  },
  {
    key: 'charge_air_low_temperature_circuit_dsl', value: 'Charge air at 100% load (LT-circuit)', unit: 'kW'
  },
  {
    key: 'charge_air_high_temperature_circuit_dsl', value: 'Charge air at 100% load (HT-circuit)', unit: 'kW'
  },
  {
    key: 'lubrication_oil_dsl', value: 'Lubrication oil at 100% load', unit: 'kW'
  },
  {
    key: 'convection_radiation_dsl', value: 'Radiation at 100% load', unit: 'kW'
  },
  {
    key: 'jacket_water_gas', value: 'Jacket water at 100% load, gas mode', unit: 'kW'
  },
  {
    key: 'charge_air_arctic_option_gas',
    value: 'Charge air at 100% load (LT-circuit, Arctic option), gas mode', unit: 'kW'
  },
  {
    key: 'charge_air_low_temperature_circuit_gas', value: 'Charge air at 100% load (LT-circuit), gas mode', unit: 'kW'
  },
  {
    key: 'charge_air_high_temperature_circuit_gas', value: 'Charge air at 100% load (HT-circuit), gas mode', unit: 'kW'
  },
  {
    key: 'lubrication_oil_gas', value: 'Lubrication oil at 100% load, gas mode', unit: 'kW'
  },
  {
    key: 'convection_radiation_gas', value: 'Radiation at 100% load, gas mode', unit: 'kW'
  },
  {
    key: 'fuel_system', value: 'Fuel System'
  },
  {
    key: 'sub_system_note_dsl', value: 'Note'
  },
  {
    key: 'sub_system_note_gas', value: 'Note'
  },
  {
    key: 'pressure_before_injection_pump_max', value: 'FuelPressureBeforeInjPumpMax', unit: 'kPa'
  },
  {
    key: 'pressure_before_injection_pump_min', value: 'FuelPressureBeforeInjPumpMin', unit: 'kPa'
  },
  {
    key: 'pressure_before_injection_pump_nom', value: 'Nominal fuel pressure before injection pumps', unit: 'kPa'
  },
  {
    key: 'pressure_before_injection_pump_nom_unifuel', value: 'FuelPressureBeforeInjPumpNomUnifuel', unit: 'kPa'
  },
  {
    key: 'pressure_tolerance_before_injection_pump_nom',
    value: 'Tolerance of fuel oil pressure before injection pumps', unit: 'kPa'
  },
  {
    key: 'pressure_before_built_on_fuel_pump_min', value: 'Pressure before built-on fuel feed pump, min', unit: 'kPa'
  },
  {
    key: 'pressure_before_built_on_fuel_pump_max', value: 'Pressure before built-on fuel feed pump, max', unit: 'kPa'
  },
  {
    key: 'pressure_before_built_on_fuel_pump_nom', value: 'Pressure before built-on fuel feed pump, nom', unit: 'kPa'
  },
  {
    key: 'circulation_pump_capacity_min', value: 'Circulation pump capacity, min', unit: 'm³/h'
  },
  {
    key: 'circulation_pump_capacity_max', value: 'Circulation pump capacity, max', unit: 'm³/h'
  },
  {
    key: 'engine_driven_pump_capacity_flow', value: 'Engine driven fuel oil pump flow', unit: 'm³/h'
  },
  {
    key: 'electrically_driven_pump_capacity_at50_hz', value: 'Electric pump capacity (50 Hz)', unit: 'm³/h'
  },
  {
    key: 'electrically_driven_pump_capacity_at60_hz', value: 'Electric pump capacity (60 Hz)', unit: 'm³/h'
  },
  {
    key: 'fuel_cons_pilot100_gas', value: 'Pilot fuel consumption at 100% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'fuel_cons_pilot85_gas', value: 'Pilot fuel consumption at 85% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'fuel_cons_pilot75_gas', value: 'Pilot fuel consumption at 75% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'fuel_cons_pilot50_gas', value: 'Pilot fuel consumption at 50% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'gas_methane_number_min', value: 'Gas methane number (MN), min'
  },
  {
    key: 'gas_lower_heating_value_min', value: 'Lower heating value (LHV), min', unit: 'MJ/Nm³'
  },
  {
    key: 'gas_pressure_before_engine_lhv24_min',
    value: 'Minimum gas pressure before engine without derating, LHV >24MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'gas_pressure_before_engine_lhv26_min',
    value: 'Minimum gas pressure before engine without derating, LHV >26MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'gas_pressure_before_engine_lhv28_min',
    value: 'Minimum gas pressure before engine without derating, LHV >28MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'gas_pressure_before_engine_lhv30_min',
    value: 'Minimum gas pressure before engine without derating, LHV >30MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'gas_pressure_before_engine_lhv32_min',
    value: 'Minimum gas pressure before engine without derating, LHV >32MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'gas_pressure_before_engine_lhv33_min',
    value: 'Minimum gas pressure before engine without derating, LHV >33MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'gas_pressure_before_engine_lhv34_min',
    value: 'Minimum gas pressure before engine without derating, LHV >34MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'gas_pressure_before_engine_lhv36_min',
    value: 'Minimum gas pressure before engine without derating, LHV >36MJ/m3N', unit: 'kPa (a)'
  },
  {
    key: 'leak_quantity_mdf_full_load_dsl',
    value: 'Leak fuel quantity (LFO), clean fuel at 100% load', unit: 'kg/h'
  },
  {
    key: 'leak_quantity_mdf_full_load_gas',
    value: 'Leak fuel quantity (LFO), clean fuel at 100% load, gas', unit: 'kg/h'
  },
  {
    key: 'leak_quantity_hfo_full_load', value: 'Leak fuel quantity (HFO), clean fuel at 100% load', unit: 'kg/h'
  },
  {
    key: 'pilot_consumption_at100_load_dsl', value: 'Pilot fuel consumption at 100% load, dsl mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at85_load_dsl', value: 'Pilot fuel consumption at 85% load, dsl mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at75_load_dsl', value: 'Pilot fuel consumption at 75% load, dsl mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at50_load_dsl', value: 'Pilot fuel consumption at 50% load, dsl mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at25_load_dsl', value: 'Pilot fuel consumption at 25% load, dsl mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at100_load_gas', value: 'Pilot fuel consumption at 100% load, gas mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at85_load_gas', value: 'Pilot fuel consumption at 85% load, gas mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at75_load_gas', value: 'Pilot fuel consumption at 75% load, gas mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at50_load_gas', value: 'Pilot fuel consumption at 50% load, gas mode', unit: 'g/kWh'
  },
  {
    key: 'pilot_consumption_at25_load_gas', value: 'Pilot fuel consumption at 25% load, gas mode', unit: 'g/kWh'
  },
  {
    key: 'consumption_at100_load_dsl_hfo', value: 'Fuel consumption at 100% load (HFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at85_load_dsl_hfo', value: 'Fuel consumption at 85% load (HFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at75_load_dsl_hfo', value: 'Fuel consumption at 75% load (HFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at50_load_dsl_hfo', value: 'Fuel consumption at 50% load (HFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at25_load_dsl_hfo', value: 'Fuel consumption at 25% load (HFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at100_load_dsl_lfo', value: 'Fuel consumption at 100% load (LFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at85_load_dsl_lfo', value: 'Fuel consumption at 85% load (LFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at75_load_dsl_lfo', value: 'Fuel consumption at 75% load (LFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at50_load_dsl_lfo', value: 'Fuel consumption at 50% load (LFO)', unit: 'g/kWh'
  },
  {
    key: 'consumption_at25_load_dsl_lfo', value: 'Fuel consumption at 25% load (LFO)', unit: 'g/kWh'
  },
  {
    key: 'heat_rate_at100_load_gas', value: 'Heat rate at 100% load (GAS)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at85_load_gas', value: 'Heat rate at 85% load (GAS)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at75_load_gas', value: 'Heat rate at 75% load (GAS)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at50_load_gas', value: 'Heat rate at 50% load (GAS)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at25_load_gas', value: 'Heat rate at 25% load (GAS)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at100_load_gas_total', value: 'Heat rate at 100% load (GAS), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at85_load_gas_total', value: 'Heat rate at 85% load (GAS), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at75_load_gas_total', value: 'Heat rate at 75% load (GAS), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at50_load_gas_total', value: 'Heat rate at 50% load (GAS), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at25_load_gas_total', value: 'Heat rate at 25% load (GAS), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at100_load_flex1', value: 'Energy consumption at 100% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at85_load_flex1', value: 'Energy consumption at 85% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at75_load_flex1', value: 'Energy consumption at 75% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at50_load_flex1', value: 'Energy consumption at 50% load, Methanol', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at100_load_flex1_total', value: 'Energy consumption at 100% load, Methanol (total)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at85_load_flex1_total', value: 'Energy consumption at 85% load, Methanol (total)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at75_load_flex1_total', value: 'Energy consumption at 75% load, Methanol (total)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at50_load_flex1_total', value: 'Energy consumption at 50% load, Methanol (total)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at100_load_gas_ethane', value: 'Heat rate at 100% load (Gas Ethane)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at90_load_gas_ethane', value: 'Heat rate at 90% load (Gas Ethane)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at75_load_gas_ethane', value: 'Heat rate at 75% load (Gas Ethane)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at50_load_gas_ethane', value: 'Heat rate at 50% load (Gas Ethane)', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at100_load_gas_ethane_total', value: 'Heat rate at 100% load (Gas Ethane), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at90_load_gas_ethane_total', value: 'Heat rate at 90% load (Gas Ethane), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at75_load_gas_ethane_total', value: 'Heat rate at 75% load (Gas Ethane), total', unit: 'kJ/kWh'
  },
  {
    key: 'heat_rate_at50_load_gas_ethane_total', value: 'Heat rate at 50% load (Gas Ethane), total', unit: 'kJ/kWh'
  },
  {
    key: 'calculated_fuel_oil_flow', value: 'Calculated fuel oil flow to engine', unit: 'm³/h'
  },
  {
    key: 'lubricating_oil_system', value: 'Lubricating Oil System'
  },
  {
    key: 'sub_system_note', value: 'Note'
  },
  {
    key: 'pressure_before_bearings_nom', value: 'Pressure before bearings, nom (PT201)', unit: 'kPa'
  },
  {
    key: 'pressure_before_bearings_alarm', value: 'Pressure before bearings, alarm', unit: 'kPa'
  },
  {
    key: 'pressure_before_bearings_stop', value: 'Pressure before bearings, stop', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_max', value: 'Pressure after pump, max', unit: 'kPa'
  },
  {
    key: 'suction_ability_built_on_pump', value: 'Suction ability, including pipe loss, max', unit: 'kPa'
  },
  {
    key: 'priming_pressure_nom', value: 'Priming pressure, nom (PT201)', unit: 'kPa'
  },
  {
    key: 'priming_pressure_alarm', value: 'Priming pressure, alarm', unit: 'kPa'
  },
  {
    key: 'temperature_before_bearings_nom', value: 'Temperature before bearings, nom (TE201)', unit: '°C'
  },
  {
    key: 'temperature_before_bearings_alarm', value: 'Temperature before bearings, alarm', unit: '°C'
  },
  {
    key: 'temperature_after_engine', value: 'Temperature after engine, approx.', unit: '°C'
  },
  {
    key: 'engine_driven_pump_capacity_fpp', value: 'Pump capacity (main), engine driven', unit: 'm³/h'
  },
  {
    key: 'engine_driven_pump_capacity', value: 'Pump capacity (main), engine driven', unit: 'm³/h'
  },
  {
    key: 'electrically_driven_pump_capacity', value: 'Pump capacity (main), electrically driven', unit: 'm³/h'
  },
  {
    key: 'flow_through_engine', value: 'Oil flow through engine', unit: 'm³/h'
  },
  {
    key: 'priming_pump_capacity_at50_hz', value: 'Priming pump capacity (50 Hz)', unit: 'm³/h'
  },
  {
    key: 'priming_pump_capacity_at60_hz', value: 'Priming pump capacity (60 Hz)', unit: 'm³/h'
  },
  {
    key: 'oil_volume_separate_oil_tank', value: 'Oil volume in separate system oil tank', unit: 'm³'
  },
  {
    key: 'oil_volume_nom', value: 'Oil volume, nom', unit: 'm³'
  },
  {
    key: 'oil_volume_min', value: 'Minimum oil volume in wet sump at running engine', unit: 'm³'
  },
  {
    key: 'oil_volume_max', value: 'Maximum oil volume in wet sump at running engine', unit: 'm³'
  },
  {
    key: 'filter_fineness', value: 'Filter fineness', unit: 'microns'
  },
  {
    key: 'filter_pressure_difference_alarm', value: 'Filter difference pressure alarm', unit: 'kPa'
  },
  {
    key: 'oil_consumption_full_load_dsl', value: 'Oil consumption at 100% load, approx', unit: 'g/kWh'
  },
  {
    key: 'crankcase_vent_flow', value: 'Crankcase ventilation flow', unit: 'l/min'
  },
  {
    key: 'crankcase_vent_flow_max', value: 'Crankcase ventilation flow, max', unit: 'l/min'
  },
  {
    key: 'crankcase_back_pressure_max', value: 'Crankcase ventilation back pressure in external piping, max', unit: 'kPa'
  },
  {
    key: 'high_temperature_cooling_water_system', value: 'High Temperature Cooling Water System'
  },
  {
    key: 'sub_system_note', value: 'Note'
  },
  {
    key: 'pressure_after_pump_nom', value: 'Pressure at engine, after pump, nom (PT401)', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_alarm', value: 'Pressure at engine, after pump, alarm', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_stop', value: 'Pressure at engine, after pump, stop', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_min', value: 'Pressure at engine, after pump, min (PT401)', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_max', value: 'Pressure at engine, after pump, max (PT401)', unit: 'kPa'
  },
  {
    key: 'temperature_before_cylinders', value: 'Temperature before cylinders, approx. (TE401)', unit: '°C'
  },
  {
    key: 'temperature_after_engine_nom', value: 'Temperature after cylinders, nom (TE402)', unit: '°C'
  },
  {
    key: 'temperature_after_engine_nom_without_cac',
    value: 'Temperature after cylinders without CAC, approx. (TE402)', unit: '°C'
  },
  {
    key: 'temperature_after_charge_air_cooler_nom',
    value: 'Temperature after charge air cooler, nom (TE432)', unit: '°C'
  },
  {
    key: 'temperature_after_engine_alarm', value: 'Temperature after engine, alarm', unit: '°C'
  },
  {
    key: 'temperature_after_engine_stop', value: 'Temperature after engine, stop', unit: '°C'
  },
  {
    key: 'engine_pump_capacity_nom', value: 'Capacity of engine driven pump, nom', unit: 'm³/h'
  },
  {
    key: 'engine_pump_capacity_min', value: 'Capacity of engine driven pump, min', unit: 'm³/h'
  },
  {
    key: 'pressure_drop_over_engine_total', value: 'Pressure drop over engine, total', unit: 'kPa'
  },
  {
    key: 'pressure_drop_in_external_systems_max', value: 'Pressure drop in external system, max', unit: 'kPa'
  },
  {
    key: 'pressure_expansion_tank_min', value: 'Pressure from expansion tank, min', unit: 'kPa'
  },
  {
    key: 'pressure_expansion_tank_max', value: 'Pressure from expansion tank, max', unit: 'kPa'
  },
  {
    key: 'delivery_head_standby_pump', value: 'Delivery head of standby pump (excluding static pressure)', unit: 'kPa'
  },
  {
    key: 'water_volume_in_engine', value: 'Water volume in engine', unit: 'm³'
  },
  {
    key: 'low_temperature_cooling_water_system', value: 'Low Temperature Cooling Water System'
  },
  {
    key: 'sub_system_note', value: 'Note'
  },
  {
    key: 'pressure_after_pump_nom', value: 'Pressure at engine, after pump, nom', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_alarm', value: 'Pressure at engine, after pump, alarm', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_stop', value: 'Pressure at engine, after pump, stop', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_min', value: 'Pressure at engine, after pump, min', unit: 'kPa'
  },
  {
    key: 'pressure_after_pump_max', value: 'Pressure at engine, after pump, max', unit: 'kPa'
  },
  {
    key: 'temperature_before_engine_min', value: 'Temperature before engine, min', unit: '°C'
  },
  {
    key: 'temperature_before_engine_max', value: 'Temperature before engine, max', unit: '°C'
  },
  {
    key: 'temperature_before_engine_nom', value: 'Temperature before engine, nom (TE451)', unit: '°C'
  },
  {
    key: 'temperature_before_charge_air_cooler_nom', value: 'Temperature before charge air cooler, nom', unit: '°C'
  },
  {
    // tslint:disable-next-line:max-line-length
    key: 'temperature_before_charge_air_cooler_nom_gas', value: 'Temperature before charge air cooler, nom, gas mode', unit: '°C'
  },
  {
    key: 'temperature_after_lubrication_oil_cooler_nom', value: 'Temperature after lube oil cooler, nom', unit: '°C'
  },
  {
    // tslint:disable-next-line:max-line-length
    key: 'temperature_after_lubrication_oil_cooler_nom_gas', value: 'Temperature after lube oil cooler, nom, gas mode', unit: '°C'
  },
  {
    key: 'temperature_after_cooler_nom2_stage', value: 'Temperature LT-water outlet, nom (TE472)', unit: '°C'
  },
  {
    key: 'capacity_engine_driven_pump_nom', value: 'Capacity of engine driven pump, nom', unit: 'm³/h'
  },
  {
    key: 'capacity_engine_driven_pump_min', value: 'Capacity of engine driven pump, min', unit: 'm³/h'
  },
  {
    key: 'pressure_drop_over_charge_air_cooler', value: 'Pressure drop over charge air cooler', unit: 'kPa'
  },
  {
    key: 'pressure_drop_over_oil_cooler', value: 'Pressure drop over oil cooler', unit: 'kPa'
  },
  {
    key: 'pressure_drop_external_system_max', value: 'Pressure drop in external system, max', unit: 'kPa'
  },
  {
    key: 'pressure_expansion_tank_min', value: 'Pressure from expansion tank, min', unit: 'kPa'
  },
  {
    key: 'pressure_from_expansion_tank_max', value: 'Pressure from expansion tank, max', unit: 'kPa'
  },
  {
    key: 'delivery_head_standby_pump', value: 'Delivery head of stand-by pump (excluding static pressure)', unit: 'kPa'
  },
  {
    key: 'compressed_air_system', value: 'Compressed Air System'
  },
  {
    key: 'sub_system_note', value: 'Note'
  },
  {
    key: 'air_supply_pressure_nom', value: 'Pressure, nom (PT301)', unit: 'kPa'
  },
  {
    key: 'air_supply_pressure_min', value: 'Pressure, min (PT301)', unit: 'kPa'
  },
  {
    key: 'air_supply_pressure_max', value: 'Pressure, max (PT301)', unit: 'kPa'
  },
  {
    key: 'air_supply_pressure_alarm', value: 'Air supply low pressure engine alarm, engine inlet (PT301)', unit: 'kPa'
  },
  {
    key: 'air_vessel_pressure_min', value: 'Low pressure limit in air vessels', unit: 'kPa'
  },
  {
    key: 'air_consumption_start_without_propeller_engaged',
    value: 'Air consumption per start (average)', unit: 'Nm³'
  },
  {
    key: 'air_consumption_start_with_propeller_engaged',
    value: 'Air consumption per start with propeller shaft engaged (average), automatic', unit: 'Nm³'
  },
  {
    key: 'air_consumption_start_with_propeller_engaged_slowturn',
    value: 'Air consumption per start and high inertia (average), automatic with slowturn', unit: 'Nm³'
  },
  {
    key: 'starting_air_consumption_average_slowturn_dsl',
    value: 'Starting air consumption/start (average), automatic with slowturn', unit: 'Nm³'
  },
  {
    key: 'starting_air_consumption_average_automatic_dsl',
    value: 'Starting air consumption/start (average), automatic', unit: 'Nm³'
  },
  {
    key: 'starting_air_consumption_average_slowturn_gas',
    value: 'Starting air consumption/start (average), automatic with slowturn, gas mode', unit: 'Nm³'
  },
  {
    key: 'starting_air_consumption_average_automatic_gas',
    value: 'Starting air consumption/start (average), automatic, gas mode', unit: 'Nm³'
  },
  {
    key: 'starting_air_consumption_average_one_bank',
    value: 'Average starting air consumption per start, starting air valves on 1 bank', unit: 'Nm³'
  },
  {
    key: 'starting_air_consumption_average_two_banks',
    value: 'Average starting air consumption per start, starting air valves on 2 banks', unit: 'Nm³'
  },
  {
    key: 'starting_air_consumption_air_assist',
    value: 'Air Assist air consumption for first load step', unit: 'Nm³'
  },
  {
    key: 'notes', value: 'Notes', type: 'note'
  },
  {
    key: 'engine_note', value: 'Engine note:', type: 'note'
  },
  {
    key: 'combustion_air_system_note', value: 'Combustion air system note:', type: 'note'
  },
  {
    key: 'exhaust_gas_system_note', value: 'Exhaust gas system note:', type: 'note'
  },
  {
    key: 'heat_balance_note', value: 'Heat balance note:', type: 'note'
  },
  {
    key: 'fuel_system_note_dsl', value: 'Fuel system note:', type: 'note'
  },
  {
    key: 'fuel_system_note_gas', value: 'Fuel gas system note:', type: 'note'
  },
  {
    key: 'lubricating_oil_system_note', value: 'Lubricating oil system note:', type: 'note'
  },
  {
    key: 'high_temperature_system_note', value: 'High temperature cooling water system note:', type: 'note'
  },
  {
    key: 'low_temperature_system_note', value: 'Low temperature cooling water system note:', type: 'note'
  },
  {
    key: 'compressed_air_system_note', value: 'Compressed air system note:', type: 'note'
  },
];

export function getKeyValuePairByKey(key: string) {
  return map.find((x) => x.key === key);
}
